import { isEmpty, map, get } from "lodash";
import moment from "moment";

export function getTimeLabel(time, dateOnly = false, hourOnly = false, both = false, day = false) {
	if (time) {
		const days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

		const propTime = moment(time);
		if (hourOnly) {
			if (propTime.isValid()) {
				return propTime.format("h:mm A");
			}
			return moment(time, "HH:mm:ss").format("h:mm A");
		}
		if (day) {
			return `${days[propTime.day()]} ${propTime.format("DD/MM/YYYY h:mm A")}`;
		}
		if (dateOnly) {
			return propTime.format("DD/MM/YYYY");
		}
		if (both) {
			return propTime.format("DD/MM/YYYY h:mm A");
		}
		return propTime.format("DD/MM/YYYY");
	}
	return "";
}

export function dropdownFormat(data, label, value) {
	const formatData = map(data, (item, index) => {
		return { key: index + 1, text: get(item, label, ""), value: get(item, value, "") };
	});
	return formatData;
}

export function timeBetweenDatesCurrent(time, timeEnd) {
	const today = new Date(time);
	let endDate = new Date();
	if (!isEmpty(time)) {
		if (!isEmpty(timeEnd)) {
			endDate = new Date(timeEnd);
		}

		const days = parseInt((endDate - today) / (1000 * 60 * 60 * 24));
		const hours = parseInt((Math.abs(today - endDate) / (1000 * 60 * 60)) % 24);
		const minutes = parseInt((Math.abs(endDate.getTime() - today.getTime()) / (1000 * 60)) % 60);
		const seconds = parseInt((Math.abs(endDate.getTime() - today.getTime()) / 1000) % 60);

		let timeString = "";
		if (days === 0) {
			if (hours === 0) {
				if (minutes === 0) {
					timeString = `${String(seconds)}s`;
				} else {
					timeString = `${String(minutes)}m  ${String(seconds)}s`;
				}
			} else {
				timeString = `${String(hours)}h  ${String(minutes)}m  ${String(seconds)}s`;
			}
		} else {
			timeString = `${String(days)}d  ${String(hours)}h  ${String(minutes)}m  ${String(seconds)}s`;
		}
		return timeString;
	}
	return "";
}

export function pastDays(time) {
	if (time) {
		const fechaInicio = new Date(time).getTime();
		const fechaFin = new Date().getTime();
		const diff = fechaFin - fechaInicio;
		const days = parseInt(diff / (1000 * 60 * 60 * 24));
		if (days === 0) return null;
		return days;
	}
}

export function phoneFormat(string) {
	if (string != null) {
		const cleanString = string.replace(/[^\d]/g, "");
		if (cleanString.length === 10) {
			return cleanString.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
		}
		if (cleanString.length === 11) {
			return cleanString.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$1 ($2) $3-$4");
		}
		return string;
	}
}

export function currencyFormat(num, integer = false) {
	if (num !== undefined && typeof num === "string") {
		const newNum = parseFloat(num);
		let strNum = newNum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
		if (integer) {
			strNum = strNum.substring(0, strNum.length - 3);
		}
		return strNum;
	}
	if (num === null) {
		return "";
	}
	if (num !== undefined && num !== null) {
		let strNum = num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
		if (integer) {
			strNum = strNum.substring(0, strNum.length - 3);
		}
		return strNum;
	}
}
